import { createContext } from "react";
import type { DetectResponse, PlagiarismResponse } from "@shared/types";

export interface PlagiarismResult extends PlagiarismResponse {}
export interface DetectResult extends DetectResponse {}

export interface AppContextType {
	detectResult: DetectResult;
	setDetectResult: (detectResult: DetectResult) => void;
	plagiarismResult: PlagiarismResult;
	setPlagiarismResult: (plagiarismResult: PlagiarismResult) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);
